module.exports = __webpack_public_path__ + "static/media/dinosaur(16).6d1838b9.PNG";